export const supportedXpayMethods = ["apple-pay", "google-pay"] as const;

export type XpayMethod = (typeof supportedXpayMethods)[number];
